/**
 * NewFeatureChip — T327. The badge itself. It renders only when `NEW_FEATURES` says this path is
 * new AND this person has not opened it yet on this device; `Layout.handleNav` marks it seen.
 *
 * It re-reads on every navigation, which is what makes it disappear the moment he clicks rather
 * than at the next full reload.
 */

import React from 'react';
import { Chip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { isFeatureNew } from '../utils/newFeature';

interface Props {
  path: string;
  userKey?: string | number | null;
}

const NewFeatureChip: React.FC<Props> = ({ path, userKey }) => {
  const location = useLocation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const show = React.useMemo(() => isFeatureNew(path, userKey), [path, userKey, location.pathname]);
  if (!show) return null;

  return (
    <Chip
      label="New"
      size="small"
      sx={{
        height: 18,
        fontSize: '0.6rem',
        fontWeight: 700,
        bgcolor: '#1F7A63',
        color: '#fff',
        '& .MuiChip-label': { px: 0.8 },
      }}
    />
  );
};

export default NewFeatureChip;
